import moment from 'moment';
import {DraftStatus} from 'src/openapi/admin/models/DraftStatus';
import {SetUpStep} from 'src/openapi/admin/models/SetUpStep';

import type {PostponeWarningProps} from '../typedef';

export const isPostponeWarning = (draft: PostponeWarningProps): boolean => {
    if (!draft.updatedAt) {
        return false;
    }

    const daysSince = moment().diff(moment(draft.updatedAt), 'days', true);

    return daysSince > 14
        && draft.latestStep === SetUpStep.TEST_CONNECTION
        && draft.status === DraftStatus.IN_PROGRESS;
};
